"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagList = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var mithril_component_1 = require("../../components/mithril.component");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var dom_1 = require("../../dom");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var tag_state_1 = require("../../page/tag.state");
var services_1 = require("../../services");
var page_state_1 = require("../../state/page.state");
var tag_sort_state_1 = require("../../state/tag.sort.state");
var store_1 = require("../../store");
var collection_list_1 = require("../collection.list/collection.list");
var collection_toolbar_1 = require("../collection.toolbar/collection.toolbar");
var tag_card_1 = require("./tag.card");
var tag_list_style_1 = require("./tag.list.style");
(0, theme_1.addStyles)(tag_list_style_1.Style);
var CONTENT_KEY = 'tag-list';
var TagList = /** @class */ (function (_super) {
    tslib_1.__extends(TagList, _super);
    function TagList(state) {
        var _this = _super.call(this) || this;
        _this.tagCards = {};
        _this.state = state;
        _this.toolbar = new collection_toolbar_1.CollectionToolbar(_this.state, {
            title: i18n_1.T.TAG_TITLE
        });
        return _this;
    }
    TagList.prototype.onRemove = function () {
        this.tagCards = {};
    };
    Object.defineProperty(TagList.prototype, "nodes", {
        get: function () {
            var visibleTags = this.state.visibleTags;
            var content;
            if (visibleTags.length !== 0) {
                var cardChildren = [];
                for (var _i = 0, visibleTags_1 = visibleTags; _i < visibleTags_1.length; _i++) {
                    var tag = visibleTags_1[_i];
                    var tagCard = this.tagCards[tag.objectId];
                    if (tagCard == null) {
                        tagCard = this.tagCards[tag.objectId] = new tag_card_1.TagCard(this.state, tag);
                    }
                    cardChildren.push(tagCard.view());
                    var child = null;
                    if (page_state_1.CurrentState.expandedTagId === tag.objectId) {
                        child = this.viewExpandedTag();
                    }
                    else if (services_1.Services.Search.filterState.hasFilter() && services_1.Services.Search.collectionSummaries[tag.objectId] != null) {
                        child = this.viewFilteredCollectionList(tag);
                    }
                    if (child != null) {
                        cardChildren.push(child);
                    }
                }
                if (this.state.hasMore) {
                    cardChildren.push(this.loadMoreButton());
                }
                content = (0, mithril_1.m)('div', { className: tag_list_style_1.CSS.cards.container }, cardChildren);
            }
            else if (this.state.fetchState === tag_state_1.TagFetchState.UNKNOWN) {
                content = this.viewLoadingResult();
            }
            else if (this.state.fetchState !== tag_state_1.TagFetchState.HAS_TAGS) {
                content = this.viewEmptyResult();
            }
            else {
                content = this.viewSearchEmptyResult();
            }
            content.attrs.key = CONTENT_KEY;
            return (0, mithril_1.m)('div', { className: tag_list_style_1.CSS.container, onmousemove: dom_1.handleMouseMove }, [
                this.toolbar.view(),
                content
            ]);
        },
        enumerable: false,
        configurable: true
    });
    TagList.prototype.loadMoreButton = function () {
        return (0, mithril_1.m)('div', { key: 'load-more', className: tag_list_style_1.CSS.loadmore }, (0, mithril_1.m)('button', { className: 'mdl-button', onclick: this.state.loadMore }, (0, i18n_1.Translate)(i18n_1.T.LOAD_MORE)));
    };
    Object.defineProperty(TagList.prototype, "expandedCollections", {
        get: function () {
            var tagSummary = store_1.AppStore.TagSummary.get(page_state_1.CurrentState.expandedTagId);
            if (tagSummary == null) {
                return null;
            }
            var collectionSummaries = [];
            for (var _i = 0, _a = tagSummary.revisions; _i < _a.length; _i++) {
                var revision = _a[_i];
                var collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
                if (collectionSummary != null) {
                    collectionSummaries.push(collectionSummary);
                }
            }
            if (collectionSummaries.length !== tagSummary.revisions.length) {
                return null;
            }
            tag_sort_state_1.TagSortState.sortSummaries(collectionSummaries);
            page_state_1.CurrentState.Tag.resetLastSelectedCollectionIndex();
            page_state_1.CurrentState.Tag.setExpandedCollectionsUUIDs(collectionSummaries.map(function (_) { return _.uuid; }));
            return collectionSummaries;
        },
        enumerable: false,
        configurable: true
    });
    TagList.prototype.viewExpandedTag = function () {
        if (page_state_1.CurrentState.expandedTagId == null) {
            return null;
        }
        var summaries = this.expandedCollections;
        if (summaries === null) {
            return collection_list_1.CollectionList.viewLoading(page_state_1.CurrentState.expandedTagId);
        }
        var tag = store_1.AppStore.Tag.get(page_state_1.CurrentState.expandedTagId);
        return collection_list_1.CollectionList.view(this.state, tag, this.expandedCollections);
    };
    TagList.prototype.viewFilteredCollectionList = function (tag) {
        var collectionSummaries = services_1.Services.Search.collectionSummaries[tag.objectId];
        return collection_list_1.CollectionList.view(this.state, tag, collectionSummaries);
    };
    TagList.prototype.viewEmptyResult = function () {
        return (0, mithril_1.m)('div', { className: "".concat(tag_list_style_1.CSS.cards.container, " ").concat(tag_list_style_1.CSS.cards.isEmpty) }, [
            (0, mithril_1.m)('div', { className: tag_list_style_1.CSS.empty.message, key: "".concat(CONTENT_KEY, "-empty-message") }, (0, i18n_1.Translate)(i18n_1.T.TAG_FILTER__SEARCH_EMPTY))
        ]);
    };
    TagList.prototype.viewLoadingResult = function () {
        return (0, mithril_1.m)('div', { className: "".concat(tag_list_style_1.CSS.cards.container, " ").concat(tag_list_style_1.CSS.cards.isEmpty) }, spinner_1.Spinner.view());
    };
    TagList.prototype.viewSearchEmptyResult = function () {
        return (0, mithril_1.m)('div', { className: "".concat(tag_list_style_1.CSS.cards.container, " ").concat(tag_list_style_1.CSS.cards.isEmpty) }, [
            (0, mithril_1.m)('div', { className: tag_list_style_1.CSS.empty.message, key: "".concat(CONTENT_KEY, "-empty-message") }, (0, i18n_1.Translate)(i18n_1.T.TAG_FILTER__SEARCH_EMPTY)),
            (0, mithril_1.m)('button', {
                key: "".concat(CONTENT_KEY, "-clear-search"),
                className: "mdl-button ".concat(tag_list_style_1.CSS.empty.reset),
                onclick: function () { return services_1.Services.Search.reset(); }
            }, (0, i18n_1.Translate)(i18n_1.T.CLEAR_SEARCH))
        ]);
    };
    tslib_1.__decorate([
        mobx_1.computed
    ], TagList.prototype, "expandedCollections", null);
    return TagList;
}(mithril_component_1.IMithrilComponent));
exports.TagList = TagList;
//# sourceMappingURL=tag.list.js.map